<template>
  <div>
    <vs-prompt @cancel="val = ''" blur @accept="pushNotify" @close="pushNotification = false"
      :active.sync="pushNotification" accept-text="Add" title="Push Notification">
      <div class="con-exemple-prompt">
        <vs-input placeholder="Title" v-model="notify.title" />
        <vs-textarea placeholder="Body" v-model="notify.body" />
      </div>
    </vs-prompt>
    <vs-table :data="episodes.episodes" stripe>
      <div slot="header" class="items-center flex-grow justify-between m-3">
        <vs-button color="danger" type="filled" @click="DeleteSeason(season)">Delete Season</vs-button>
        <vs-button class="mx-2" color="success" type="filled"
          :to="{ name: 'addEpisode', params: { seasonId: season.id } }">Add New Episode</vs-button>

        <vs-progress indeterminate color="primary" v-if="loading">primary</vs-progress>
      </div>
      <template #thead v-if="!loading">
        <vs-th>Episode</vs-th>
        <vs-th>Arabic Title</vs-th>
        <vs-th>English Title</vs-th>
        <vs-th>Actions</vs-th>
      </template>
      <template slot-scope="{ data }" v-if="!loading">
        <tbody>
          <vs-tr v-for="(genre, index) in data" :key="index">
            <vs-td class="font">
              <vs-avatar color="dark" :text="`${genre.episode_num}`" />
            </vs-td>
            <vs-td class="font">{{ genre.ar_title }}</vs-td>
            <vs-td>{{ genre.en_title }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="edit(genre)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click="delConfirm(genre)" />
              <feather-icon title="push notify" @click="notificationDialog(genre)" icon="BellIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
  export default {
    props: ["season"],
    data() {
      return {
        episodes: [],
        loading: false,
        pushNotification: false,
        selected: [],
        notify: {
          title: "",
          body: "",
          poster: true,
        },
      };
    },
    created() {
      this.fetchSeason();
    },
    methods: {
      edit(episode){
        this.$router.push({ name: 'editEpisode', params: { id: episode.id } })
      },
      delConfirm(movie) {
        this.selected = movie;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Delete Episode`,
          text: `Are you sure to delete this item (${movie.en_title})?`,
          accept: this.del,
          close: this.close
        })
      },
      del() {
        this.axios.post(`${this.$apiUrl}/v2/episode/delete/${this.selected.id}`).then(res => {
          if (res.status == 200) {
            this.$vs.notify({
              color: 'success',
              title: 'Episode Deleted !',
              text: res.data.response
            })
          }
          this.fetchSeason();
        })
      },
      close() {
        this.selected = [];
      },
      fetchSeason() {
        this.loading = true;
        this.axios
          .get(`${this.$apiUrl}/v2/seasons/${this.season.id}`)
          .then((res) => {
            this.episodes = res.data;
            this.loading = false;
          });
      },
      DeleteSeason(season) {
        if (confirm(`Are you sure Delete Season (${season.title})?`)) {
          this.$vs.loading();
          this.axios
            .post(`${this.$apiUrl}/v2/seasons/del`, {
              season_id: season.id,

            })
            .then((res) => {
              this.$vs.loading.close();
              if (res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Season Deleted",
                  text: "",
                });
                window.location.reload();
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
            });
        }
      },
      notificationDialog(data) {
        this.selected = [];
        this.notify.title = [];
        this.notify.body = [];
        this.pushNotification = true;
        this.selected = data;
        this.notify.title = data.ar_title;
        this.notify.body = data.ar_plot;
      },
      pushNotify() {
        this.$vs.loading();
        this.axios
          .post(`${this.$apiUrl}/notify/series_notify`, {
            type: "movie",
            data: this.selected,
            options: this.notify,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Notification Push",
                text: "",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
        // this.selected=[];
        // this.notify.title=[];
        // this.notify.body=[];
      },
    },
  };
</script>